import React, { useEffect, useState } from 'react';
import DownloadModal from './downloadModal';
import ConfirmDownload from './confirmDownload';

const DownLoad = () => {
  const [closePopUp, setClosePopUp] = useState(false);
  const [confirmDownload, setConfirmDownload] = useState(false);
  const [productTarget, setProductTarget] = useState([]);

  useEffect(() => {
    if (confirmDownload === false) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [confirmDownload]);

  return (
    <>
      <section className="common download">
        <div className="container">
          <div className="mainTit">
            <h2>Download</h2>
            <p>Home > Download</p>
          </div>
        </div>
      </section>
      <section className="downloadPart">
        <div className="container">
          <h2>다운로드</h2>
          <p>
            위더스시큐리티의 제품 제안서, 브로슈어를 <br className="w500" />
            다운받을 수 있습니다.
          </p>
          <ul className="flex">
            <li>
              <div className="boxWrap">
                <div>
                  <h3>EG-Platform</h3>
                  <p>
                    이메일의 수신부터 발신까지 전구간을
                    <br className="w380" /> 체계적으로 보호하고, 발생 이슈를 모두 해결
                    <br className="w800" />
                    해주는
                    <br className="w1300" /> All-In-One 이메일 통합 보안 플랫폼
                  </p>
                </div>
              </div>
              <button
                onClick={() => {
                  setClosePopUp(!closePopUp);
                  setProductTarget('EG');
                }}
              >
                제안서 · 브로슈어 다운로드
              </button>
            </li>
            <li>
              <div className="boxWrap">
                <div>
                  <h3>SentinelOne</h3>
                  <p>
                    위협 라이프사이클의 모든 단계에서
                    <br className="w380" />
                    각종 공격으로부터 모든 엔드포인트를 방어하는
                    <br className="w380" /> 자율형 AI 엔드포인트 보안 소프트웨어
                  </p>
                </div>
              </div>
              <button
                onClick={() => {
                  setClosePopUp(!closePopUp);
                  setProductTarget('SO');
                }}
              >
                제안서 · 브로슈어 다운로드
              </button>
            </li>
            <li>
              <div className="boxWrap">
                <div>
                  <h3>BaroPAM</h3>
                  <p>
                    기존 ID/ PW를 이용한 Login 방식에
                    <br className="w380" />
                    동적 키(OTP)를 추가해 해커로부터 정보자산을
                    <br className="w380" /> 보호하는 강력한 접근제어 2차 인증 솔루션
                  </p>
                </div>
              </div>
              <button
                onClick={() => {
                  setClosePopUp(!closePopUp);
                  setProductTarget('BP');
                }}
              >
                제안서 · 브로슈어 다운로드
              </button>
            </li>
          </ul>
        </div>
      </section>
      {closePopUp && (
        <DownloadModal
          closePop={() => setClosePopUp(!closePopUp)}
          productTarget={productTarget}
          setProductTarget={setProductTarget}
          setClosePopUp={setClosePopUp}
          setConfirmDownload={setConfirmDownload}
        />
      )}
      {confirmDownload && <ConfirmDownload setConfirmDownload={setConfirmDownload} />}
    </>
  );
};

export default DownLoad;
